function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
var Icon = function(props) {
    return props.isDark ? /*#__PURE__*/ _jsxs("svg", _objectSpread({
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.0001 22.5002C19.0752 22.5002 24.0002 17.5752 24.0002 11.5001C24.0002 5.42491 19.0752 0.5 13.0001 0.5C6.92491 0.5 2 5.42491 2 11.5001C2 12.7644 2.21329 13.9789 2.60585 15.1095C3.31689 14.721 4.13267 14.5001 5.00002 14.5001C7.76147 14.5001 10.0001 16.7387 10.0001 19.5002C10.0001 20.3676 9.77921 21.1833 9.39067 21.8943C10.5213 22.2869 11.7358 22.5002 13.0001 22.5002Z",
                fill: "#505A73"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.875 16.2774V17.3333H12.125V16.2822C10.0784 15.9251 9.5 14.3338 9.5 13.4404H11.25C11.2596 13.5796 11.3891 14.4136 13 14.4136C14.2075 14.4136 14.75 13.8443 14.75 13.4404C14.75 13.1251 14.75 12.4672 13 12.4672C9.955 12.4672 9.5 10.6376 9.5 9.54764C9.5 8.29415 10.4004 7.03288 12.125 6.71074V5.6665H13.875V6.74578C15.3922 7.1448 15.9751 8.54913 15.9751 9.54764H15.1L14.225 9.56516C14.2127 9.19533 14.0369 8.57443 13 8.57443C11.8634 8.57443 11.25 9.0766 11.25 9.54764C11.25 9.91161 11.25 10.5208 13 10.5208C16.0451 10.5208 16.5001 12.3504 16.5001 13.4404C16.5001 14.6939 15.5996 15.9552 13.875 16.2774Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.00004 24.5001C7.76148 24.5001 10.0001 22.2615 10.0001 19.5C10.0001 16.7386 7.76148 14.5 5.00004 14.5C2.2386 14.5 0 16.7386 0 19.5C0 22.2615 2.2386 24.5001 5.00004 24.5001ZM4.25003 17.25C4.25003 16.8358 4.58586 16.5 5.00004 16.5C5.41422 16.5 5.75005 16.8358 5.75005 17.25V18.75H7.25006C7.66424 18.75 8.00006 19.0858 8.00006 19.5C8.00006 19.9142 7.66424 20.25 7.25006 20.25H5.75005V21.7501C5.75005 22.1643 5.41422 22.5001 5.00004 22.5001C4.58586 22.5001 4.25003 22.1643 4.25003 21.7501V20.25H2.75002C2.33584 20.25 2.00002 19.9142 2.00002 19.5C2.00002 19.0858 2.33584 18.75 2.75002 18.75H4.25003V17.25Z",
                fill: "white"
            })
        ]
    })) : /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.0001 22.5002C19.0752 22.5002 24.0002 17.5752 24.0002 11.5001C24.0002 5.42491 19.0752 0.5 13.0001 0.5C6.92491 0.5 2 5.42491 2 11.5001C2 12.7644 2.21329 13.9789 2.60585 15.1095C3.31689 14.721 4.13267 14.5001 5.00002 14.5001C7.76147 14.5001 10.0001 16.7387 10.0001 19.5002C10.0001 20.3676 9.77921 21.1833 9.39067 21.8943C10.5213 22.2869 11.7358 22.5002 13.0001 22.5002Z",
                fill: "#D0DAE7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.875 16.2774V17.3333H12.125V16.2822C10.0784 15.9251 9.5 14.3338 9.5 13.4404H11.25C11.2596 13.5796 11.3891 14.4136 13 14.4136C14.2075 14.4136 14.75 13.8443 14.75 13.4404C14.75 13.1251 14.75 12.4672 13 12.4672C9.955 12.4672 9.5 10.6376 9.5 9.54764C9.5 8.29415 10.4004 7.03288 12.125 6.71074V5.6665H13.875V6.74578C15.3922 7.1448 15.9751 8.54913 15.9751 9.54764H15.1L14.225 9.56516C14.2127 9.19533 14.0369 8.57443 13 8.57443C11.8634 8.57443 11.25 9.0766 11.25 9.54764C11.25 9.91161 11.25 10.5208 13 10.5208C16.0451 10.5208 16.5001 12.3504 16.5001 13.4404C16.5001 14.6939 15.5997 15.9552 13.875 16.2774Z",
                fill: "#194BFB"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.00004 24.5001C7.76148 24.5001 10.0001 22.2615 10.0001 19.5C10.0001 16.7386 7.76148 14.5 5.00004 14.5C2.2386 14.5 0 16.7386 0 19.5C0 22.2615 2.2386 24.5001 5.00004 24.5001ZM4.25003 17.25C4.25003 16.8358 4.58586 16.5 5.00004 16.5C5.41422 16.5 5.75005 16.8358 5.75005 17.25V18.75H7.25006C7.66424 18.75 8.00006 19.0858 8.00006 19.5C8.00006 19.9142 7.66424 20.25 7.25006 20.25H5.75005V21.7501C5.75005 22.1643 5.41422 22.5001 5.00004 22.5001C4.58586 22.5001 4.25003 22.1643 4.25003 21.7501V20.25H2.75002C2.33584 20.25 2.00002 19.9142 2.00002 19.5C2.00002 19.0858 2.33584 18.75 2.75002 18.75H4.25003V17.25Z",
                fill: "#194BFB"
            })
        ]
    });
};
export default Icon;
